import { makeStyles, Paper, Typography, Divider } from '@material-ui/core';
import React from 'react';
import Box from '../../../UI';
import addCommas from '../../../../utils/helpers';

export default function Letter({ copy, propertyId }) {
	const classes = useStyles();
	const { letterhead, fixed, par1, purchasePrice, conclusion } = copy;
	return (
		<Box>
			<Paper className={classes.paper}>
				<Box mb={2}>
					<Typography variant='h5'><strong>Letter of Intent</strong></Typography>
					<Typography variant='body1'><strong>ref: {propertyId}</strong></Typography>
				</Box>
				<Box display='flex' justifyContent='space-between'>
					<Box mb={4} width="50%">
						<Typography variant="body1"><strong>To: </strong></Typography>
						<Typography variant="body1">William B. Rose</Typography>
						<Typography variant="body1">Malibu</Typography>
						<Typography variant="body1">California (CA)</Typography>
						<Typography variant="body1">United States, 90263</Typography>
					</Box>
					<Box mb={2} width="50%">
						<Typography variant="body1"><strong>From: </strong></Typography>
						{letterhead.split(',').map((value, index) => (
							<Typography key={index} variant="body1">{value}</Typography>
						))}
					</Box>
				</Box>
				<Box mb={2}>
					<Typography variant="body1">{fixed}</Typography>
				</Box>
				<Divider style={{marginBottom: '1rem'}} />
				<Box mb={2}>
					<Typography variant="body1">Dear Mr. Rose,</Typography>
				</Box>
				<Box mb={2}>
					<Typography variant="body1">{par1}</Typography>
				</Box>
				<Box mb={2}>
					<Typography variant="body1"><strong>Purchase Price: </strong></Typography>
					<Typography variant="body1">£{addCommas(purchasePrice)}.00</Typography>
				</Box>
				<Box mb={4}>
					<Typography variant="body1">{conclusion}</Typography>
				</Box>
				<Box mb={2}>
					<Typography variant="body1">Sincerely,</Typography>
				</Box>
				<Box mb={2}>
					<Typography variant="body1">Saul Hudson</Typography>
				</Box>
			</Paper>
		</Box>
	);
}

const useStyles = makeStyles(theme => ({
	paper: {
		width: '100%',
		height: '100%',
		padding: theme.spacing(4),
		overflowY: 'scroll'
	},
}));
